import React, { useEffect, useState } from 'react';
import classes from "./UssdOTP.module.css";
import Header from '../components/Header';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import OTPInput from 'react-otp-input';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import SmallLoader from '../components/Loaders/SmallLoader';
import { login, verifyOtpApi, verifyOtpUssdApi } from '../http/http';
import { setUserToken } from '../store/slices/userTokenSlice';

const UssdOTP = () => {

    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(120);
    const navigate = useNavigate();
    const [resend, setResend] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [userRef, setUserRef] = useState(null);
    const { t } = useTranslation();

    const [searchParams, setSearchParams] = useSearchParams();

    const dispatch = useDispatch();

    useEffect(() => {
        if (searchParams.get("user_ref")) {
            setUserRef(searchParams.get("user_ref"));
        } else {
            navigate("/");
        }
    }, []);

    const handleFormSubmission = async () => {
        try {
            if (otp.length <= 3) {
                return;
            }

            setLoading(true);
            const response = await verifyOtpUssdApi(userRef, otp);
            setLoading(false);

            if (response?.data?.status == 1) {
                toast.success(t("90"));

                await login({ msisdn: response?.data?.msisdn })
                    .then((res) => {
                        setLoading(false);
                        dispatch(setUserToken(res?.data?.result?.token));
                        navigate("/home", { replace: true, state: null });
                        toast.success(t("84"));
                    })
                    .catch((err) => {
                        setLoading(false);
                        if (err?.response?.data?.error?.status == 1) {
                            navigate("/low-balance");
                        }
                        else {
                            toast.error(t("92"));
                        }
                    });
            }

            if (response?.data?.status == 2) {
                toast.success(t("91"));
                navigate("/low-balance");
            }

            // setLoading(false);
            // navigate("/confirmation", {
            //     state: {
            //         msisdn: msisdn,
            //         extRef: extRef,
            //     }
            // })

        } catch (error) {
            setLoading(false);
            console.log(error, 'error---');

            if (error?.response?.data?.status == 8) {
                toast.error(t("88"));
            }
            else if (error?.response?.data?.status == 0) {
                toast.error(t("93"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.error(t("94"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, []);

    useEffect(() => {
        if (timer <= 0) {
            navigate("/");
        }
    }, [timer]);

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.otp_description}>
                    <h2 className={classes.title}>{t("67")}</h2>
                    <p className={classes.text}>
                        {t("68")} {resend && t("71")} {t("69")}
                        <span className={classes.bold}> {t("131")} </span>
                        {t("70")}
                    </p>
                </div>

                <div className={classes.otp_input_container}>
                    <OTPInput
                        value={otp}
                        shouldAutoFocus
                        onChange={setOtp}
                        numInputs={4}
                        renderSeparator={<span className={classes.gap}></span>}
                        renderInput={(props) => (
                            <input {...props} type="number" className={classes.input_box} />
                        )}
                    />
                </div>

                <div className={classes.time_container}>
                    <p className={classes.time_text}>{t("72")} {timer} {t("73")}</p>
                </div>

                {(loading || resendLoading) ? <div style={{ width: "100%", display: "grid", placeContent: "center" }}>
                    <SmallLoader />
                </div> : (
                    <div className={classes.btn_container}>
                        <button
                            type="button"
                            className={classes.confirm_btn}
                            disabled={loading}
                            onClick={handleFormSubmission}
                        >
                            {t("74")}
                        </button>
                        {/* <button
                            type="button"
                            className={classes.resend_btn}
                            disabled={resendLoading}
                            onClick={resendOtpHandler}
                        >
                            {t("75")}
                        </button> */}
                    </div>
                )}



            </div>
        </>
    )
}

export default UssdOTP